export enum GetSurveys {
  Request = 'GET_SURVEYS_REQUEST',
  Success = 'GET_SURVEYS_SUCCESS',
  Failed = 'GET_SURVEYS_FAILED',
}

export enum GetPulseSurveys {
  Request = 'GET_PULSE_SURVEYS_REQUEST',
  Success = 'GET_PULSE_SURVEYS_SUCCESS',
  Failed = 'GET_PULSE_SURVEYS_FAILED',
}
export enum GetPulseSurveysSearch {
  Request = 'GET_PULSE_SURVEYS_SEARCH_REQUEST',
  Success = 'GET_PULSE_SURVEYS_SEARCH_SUCCESS',
  Failed = 'GET_PULSE_SURVEYS_SEARCH_FAILED',
}

export enum GetGroupSurveys {
  Request = 'GET_GROUP_SURVEYS_REQUEST',
  Success = 'GET_GROUP_SURVEYS_SUCCESS',
  Failed = 'GET_GROUP_SURVEYS_FAILED',
}
export enum GetGroupSurveysSearch {
  Request = 'GET_GROUP_SURVEYS_SEARCH_REQUEST',
  Success = 'GET_GROUP_SURVEYS_SEARCH_SUCCESS',
  Failed = 'GET_GROUP_SURVEYS_SEARCH_FAILED',
}

export enum GetPeopleSurveys {
  Request = 'GET_PEOPLE_SURVEYS_REQUEST',
  Success = 'GET_PEOPLE_SURVEYS_SUCCESS',
  Failed = 'GET_PEOPLE_SURVEYS_FAILED',
}
export enum GetPeopleSurveysSearch {
  Request = 'GET_PEOPLE_SURVEYS_SEARCH_REQUEST',
  Success = 'GET_PEOPLE_SURVEYS_SEARCH_SUCCESS',
  Failed = 'GET_PEOPLE_SURVEYS_SEARCH_FAILED',
}

export enum AddSurvey {
  Request = 'ADD_SURVEY_REQUEST',
  Success = 'ADD_SURVEY_SUCCESS',
  Failed = 'ADD_SURVEY_FAILED',
}

export enum AddManagerSurvey {
  Request = 'ADD_MANAGER_SURVEY_REQUEST',
  Success = 'ADD_MANAGER_SURVEY_SUCCESS',
  Failed = 'ADD_MANAGER_SURVEY_FAILED',
}

export enum CreateUserPullSurvey {
  Request = 'CREATE_USER_PULL_SURVEY_REQUEST',
  Success = 'CREATE_USER_PULL_SURVEY_SUCCESS',
  Failed = 'CREATE_USER_PULL_SURVEY_FAILED',
}

export enum CreateTeamSurvey {
  Request = 'CREATE_TEAM_SURVEY_REQUEST',
  Success = 'CREATE_TEAM_SURVEY_SUCCESS',
  Failed = 'CREATE_TEAM_SURVEY_FAILED',
}

export enum CopySurvey {
  Request = 'COPY_SURVEYS_REQUEST',
  Success = 'COPY_SURVEYS_SUCCESS',
  Failed = 'COPY_SURVEYS_FAILED',
}

export enum DeleteSurvey {
  Request = 'DELETE_SURVEY_REQUEST',
  Success = 'DELETE_SURVEY_SUCCESS',
  Failed = 'DELETE_SURVEY_FAILED',
}

export const GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST';
export const GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
export const GET_SURVEY_FAILED = 'GET_SURVEY_FAILED';

export enum EditSurvey {
  Request = 'EDIT_SURVEY_REQUEST',
  Success = 'EDIT_SURVEY_SUCCESS',
  Failed = 'EDIT_SURVEY_FAILED',
}

export const RESET_SURVEYS = 'RESET_SURVEYS';
export const RESET_SCHEDULES = 'RESET_SCHEDULES';

export const GET_SCHEDULES_REQUEST = 'GET_SCHEDULES_REQUEST';
export const GET_SCHEDULES_SUCCESS = 'GET_SCHEDULES_SUCCESS';
export const GET_SCHEDULES_FAILED = 'GET_SCHEDULES_FAILED';

export const GET_TOPICS_FOR_SURVEY_REQUEST = 'GET_TOPICS_FOR_SURVEY_REQUEST';
export const GET_TOPICS_FOR_SURVEY_SUCCESS = 'GET_TOPICS_FOR_SURVEY_SUCCESS';
export const GET_TOPICS_FOR_SURVEY_FAILED = 'GET_TOPICS_FOR_SURVEY_FAILED';

export const SAVE_TOPICS_FOR_SURVEY_REQUEST = 'SAVE_TOPICS_FOR_SURVEY_REQUEST';
export const SAVE_TOPICS_FOR_SURVEY_SUCCESS = 'SAVE_TOPICS_FOR_SURVEY_SUCCESS';
export const SAVE_TOPICS_FOR_SURVEY_FAILED = 'SAVE_TOPICS_FOR_SURVEY_FAILED';

export enum typesForFetchSegments {
  Request = 'FETCH_SEGMENTS_BY_ID_REQUEST',
  Success = 'FETCH_SEGMENTS_BY_ID_SUCCESS',
  Failed = 'FETCH_SEGMENTS_BY_ID_FAILED',
}

export enum typesForFetchSurveyCycles {
  Request = 'FETCH_SURVEY_CYCLES_REQUEST',
  Success = 'FETCH_SURVEY_CYCLES_SUCCESS',
  Failed = 'FETCH_SURVEY_CYCLES_FAILED',
}

export enum typesForFetchSurveysCycles {
  Request = 'FETCH_SURVEYS_CYCLES_REQUEST',
  Success = 'FETCH_SURVEYS_CYCLES_SUCCESS',
  Failed = 'FETCH_SURVEYS_CYCLES_FAILED',
}
